(function($){
    $('.single-investment .more a').on('click', function(e){
        e.preventDefault();
        $(this).closest('.single-investment').find('.bottom-info').slideToggle({
            start: function () {
                $(this).css({
                    display: "flex"
                })
            }
        })
        $(this).closest('.single-investment').toggleClass('opened');
    });
    $('.show-panel').on('click', function(e){
        e.preventDefault();
        $('.sidebar').addClass('showed');
    });
    $('.close-panel').on('click', function(e){
        e.preventDefault();
        $('.sidebar').removeClass('showed');
    });
    $('.close-investment-form').on('click', function(e){
        e.preventDefault();
        $('.add-investment-form-container').fadeOut(500);
    });

    $('.add-investment a').on('click', function(e){
        e.preventDefault();
        $('.add-investment-form-container').fadeIn({
            start: function () {
                $(this).css({
                    display: "flex"
                })
            }
        });
    });

    $('.summary-on-checkout a').on('click', function(){
        $(this).closest('.used-code').remove();
    });


    $('.variant-setter').on('click', function(){
        $('#' + $(this).attr('data-variant-selector')).val($(this).attr('data-value')).trigger('change');
        $(this).closest('.color').find('.active').removeClass('active');
        $(this).addClass('active');
    })



})(jQuery);